// src/components/CatylexLogo.tsx
import * as React from "react";
import CatylexLogoImage from "../../assets/1200px-Catylex.png";

interface CatylexLogoProps {
  height?: number;
  variant?: "default" | "compact";
}

/**
 * Reusable Catylex logo component with consistent branding and interactions
 * Used across different placement options
 */
const CatylexLogo: React.FC<CatylexLogoProps> = ({ height = 28, variant = "default" }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <a
      href="https://dandilion.catylex.net/c/home" // "https://bhi-sandbox.catylex.net/c/search"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Visit Catylex - Legal Repository Partner"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        textDecoration: "none",
        transition: "all 0.2s ease",
        opacity: isHovered ? 0.8 : 1,
        transform: isHovered ? "scale(1.02)" : "scale(1)",
        flexShrink: 0,
      }}
      title="Powered by Catylex"
    >
      <img
        src={CatylexLogoImage}
        alt="Catylex Logo"
        style={{
          height: `${height}px`,
          width: "auto",
          display: "block",
        }}
      />
    </a>
  );
};

export default CatylexLogo;
